import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'splitWords',
    standalone: false
})
export class SplitWordsPipe implements PipeTransform {

  transform(input: string, separator: string, index?: number): any {

    // Index starts at 0
    // If index is null return the string array else return the string at the index location
    if (input && input.length > 0) {
      const splitArray = input.split(separator);
      if (index < splitArray.length) {
        return splitArray[0];
      }
    } else {
      return input;
    }
  }
}
